export default __webpack_public_path__ + "static/media/vitLogo.bbebeff5.png";